import { addDays, startOfDay } from 'date-fns';

const now = startOfDay(new Date());

export const inverterValues = [
  { date: addDays(now, -80), charge: 218.46, discharge: -214.78 },
  { date: addDays(now, -79), charge: 154.84, discharge: -152.23 },
  { date: addDays(now, -78), charge: 175.49, discharge: -172.53 },
  { date: addDays(now, -77), charge: 172.15, discharge: -169.24 },
  { date: addDays(now, -76), charge: 171.36, discharge: -168.47 },
  { date: addDays(now, -75), charge: 230.52, discharge: -226.64 },
  { date: addDays(now, -74), charge: 233.1, discharge: -229.17 },
  { date: addDays(now, -73), charge: 174.89, discharge: -171.94 },
  { date: addDays(now, -72), charge: 231.24, discharge: -227.34 },
  { date: addDays(now, -71), charge: 237.76, discharge: -233.75 },
  { date: addDays(now, -70), charge: 202.71, discharge: -199.29 },
  { date: addDays(now, -69), charge: 177.78, discharge: -174.78 },
  { date: addDays(now, -68), charge: 224.18, discharge: -220.4 },
  { date: addDays(now, -67), charge: 169.24, discharge: -166.39 },
  { date: addDays(now, -66), charge: 223.96, discharge: -220.18 },
  { date: addDays(now, -65), charge: 213.58, discharge: -209.98 },
  { date: addDays(now, -64), charge: 233.47, discharge: -229.53 },
  { date: addDays(now, -63), charge: 170.87, discharge: -167.99 },
  { date: addDays(now, -62), charge: 229.32, discharge: -225.45 },
  { date: addDays(now, -61), charge: 196.63, discharge: -193.32 },
  { date: addDays(now, -60), charge: 170.84, discharge: -167.96 },
  { date: addDays(now, -59), charge: 170.43, discharge: -167.56 },
  { date: addDays(now, -58), charge: 194.8, discharge: -191.52 },
  { date: addDays(now, -57), charge: 195.7, discharge: -192.4 },
  { date: addDays(now, -56), charge: 161.04, discharge: -158.32 },
  { date: addDays(now, -55), charge: 151.34, discharge: -148.79 },
  { date: addDays(now, -54), charge: 179.58, discharge: -176.55 },
  { date: addDays(now, -53), charge: 215.54, discharge: -211.91 },
  { date: addDays(now, -52), charge: 240.43, discharge: -236.38 },
  { date: addDays(now, -51), charge: 213.17, discharge: -209.58 },
  { date: addDays(now, -50), charge: 240.29, discharge: -236.24 },
  { date: addDays(now, -49), charge: 235.42, discharge: -231.45 },
  { date: addDays(now, -48), charge: 169.63, discharge: -166.77 },
  { date: addDays(now, -47), charge: 227.95, discharge: -224.11 },
  { date: addDays(now, -46), charge: 222.96, discharge: -219.2 },
  { date: addDays(now, -45), charge: 175.01, discharge: -172.06 },
  { date: addDays(now, -44), charge: 229.13, discharge: -225.26 },
  { date: addDays(now, -43), charge: 227.87, discharge: -224.03 },
  { date: addDays(now, -42), charge: 182.85, discharge: -179.77 },
  { date: addDays(now, -41), charge: 197.43, discharge: -194.11 },
  { date: addDays(now, -40), charge: 161.65, discharge: -158.92 },
  { date: addDays(now, -39), charge: 209.24, discharge: -205.71 },
  { date: addDays(now, -38), charge: 165.7, discharge: -162.9 },
  { date: addDays(now, -37), charge: 226.14, discharge: -222.33 },
  { date: addDays(now, -36), charge: 171.15, discharge: -168.26 },
  { date: addDays(now, -35), charge: 184.09, discharge: -180.98 },
  { date: addDays(now, -34), charge: 156.35, discharge: -153.71 },
  { date: addDays(now, -33), charge: 158.03, discharge: -155.36 },
  { date: addDays(now, -32), charge: 201.19, discharge: -197.8 },
  { date: addDays(now, -31), charge: 198.55, discharge: -195.21 },
  { date: addDays(now, -30), charge: 161.49, discharge: -158.77 },
  { date: addDays(now, -29), charge: 178.95, discharge: -175.94 },
  { date: addDays(now, -28), charge: 150.29, discharge: -147.75 },
  { date: addDays(now, -27), charge: 190.44, discharge: -187.23 },
  { date: addDays(now, -26), charge: 208.56, discharge: -205.04 },
  { date: addDays(now, -25), charge: 194.74, discharge: -191.46 },
  { date: addDays(now, -24), charge: 232.66, discharge: -228.74 },
  { date: addDays(now, -23), charge: 212.33, discharge: -208.75 },
  { date: addDays(now, -22), charge: 179.75, discharge: -176.72 },
  { date: addDays(now, -21), charge: 222.99, discharge: -219.23 },
  { date: addDays(now, -20), charge: 201.45, discharge: -198.06 },
  { date: addDays(now, -19), charge: 218.29, discharge: -214.61 },
  { date: addDays(now, -18), charge: 187.55, discharge: -184.39 },
  { date: addDays(now, -17), charge: 195.68, discharge: -192.38 },
  { date: addDays(now, -16), charge: 191.84, discharge: -188.61 },
  { date: addDays(now, -15), charge: 152.0, discharge: -149.44 },
  { date: addDays(now, -14), charge: 192.24, discharge: -189.0 },
  { date: addDays(now, -13), charge: 212.99, discharge: -209.4 },
  { date: addDays(now, -12), charge: 235.15, discharge: -231.19 },
  { date: addDays(now, -11), charge: 195.49, discharge: -192.19 },
  { date: addDays(now, -10), charge: 200.16, discharge: -196.79 },
  { date: addDays(now, -9), charge: 203.28, discharge: -199.85 },
  { date: addDays(now, -8), charge: 193.0, discharge: -189.75 },
  { date: addDays(now, -7), charge: 208.83, discharge: -205.31 },
  { date: addDays(now, -6), charge: 156.33, discharge: -153.7 },
  { date: addDays(now, -5), charge: 200.42, discharge: -197.04 },
  { date: addDays(now, -4), charge: 204.91, discharge: -201.46 },
  { date: addDays(now, -3), charge: 216.95, discharge: -213.29 },
  { date: addDays(now, -2), charge: 194.97, discharge: -191.69 },
  { date: addDays(now, -1), charge: 183.16, discharge: -180.07 },
  { date: addDays(now, 0), charge: 155.55, discharge: -152.93 },
];
